<script>
	import { activeFeature, activeMetric } from "./stores.js";
	import MetricsMenuItem from "./MetricsMenuItemCC.svelte";
	import { afterUpdate } from "svelte";
	import { getMetric, getValues, geoData } from "./utils";

	export let metrics;

	let selectedMetric = $activeMetric;
	let id;

	$: props = metric => {
		let values = getValues($activeFeature, metric);
		let id = metric.id;
		let title = metric.position == "list" ? metric.name : "";
		let num = values.formatted;
		let percent = (values.value - metric.min) / (metric.max - metric.min);

		// hack USA cc_debt_total - percent > 1 use metric.mean
		let color = metric.colorScale(percent > 1 ? metric.mean : values.value);
		if (percent > 1)
			percent = (metric.mean - metric.min) / (metric.max - metric.min);

		if (metric.direction == "d") percent = 1 - percent;

		let classes = "item";
		if (metric == $activeMetric) classes += " active";
		if (metric == selectedMetric) classes += " selected";

		return { id, title, num, classes, color, percent };
	};

	function click(e) {
		selectedMetric = $activeMetric;
	}

	function mousemove(e) {
		if (!e.target.dataset || !e.target.dataset.id) return;
		if (id != e.target.dataset.id) {
			id = e.target.dataset.id;
			$activeMetric = getMetric(metrics, id);
		}
	}

	function mouseleave(e) {
		$activeMetric = selectedMetric;
		id = null;
	}
</script>

<style type="text/scss">
	@import "./style/vars";
</style>

<!-- <h1>
		{$activeFeature.properties.NAME}
	</h1> -->

<div
	class="metrics"
	on:click={click}
	on:mousemove={mousemove}
	on:mouseleave={mouseleave}>
	<div class="list">
		{#each metrics as metric}
			{#if metric.position == 'list'}
				<MetricsMenuItem {...props(metric)} />
			{/if}
		{/each}
	</div>

	<table class="grid">
		<tr>
			<th />
			<th class="">Payoﬀ at 15% of average income</th>
			<th>Payoﬀ at 15% of minimum wage</th>
			<th>Payoﬀ at minimum payment amount</th>
		</tr>
		<tr>
			<th>Months</th>
			<td>
				<MetricsMenuItem
					{...props(getMetric(metrics, 'months_15_ave_income'))} />
			</td>
			<td>
				<MetricsMenuItem
					{...props(getMetric(metrics, 'months_15_min_wage'))} />
			</td>
			<td>
				<MetricsMenuItem
					{...props(getMetric(metrics, 'months_min_payment'))} />
			</td>
		</tr>
		<tr>
			<th>Amount</th>
			<td>
				<MetricsMenuItem
					{...props(getMetric(metrics, 'total_15_ave_income'))} />
			</td>
			<td>
				<MetricsMenuItem
					{...props(getMetric(metrics, 'total_15_min_wage'))} />
			</td>
			<td>
				<MetricsMenuItem
					{...props(getMetric(metrics, 'total_min_payment'))} />
			</td>
		</tr>
	</table>
</div>
